import { render, staticRenderFns } from "./seasonprices.vue?vue&type=template&id=a3b5345e&"
import script from "./seasonprices.vue?vue&type=script&lang=js&"
export * from "./seasonprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3b5345e')) {
      api.createRecord('a3b5345e', component.options)
    } else {
      api.reload('a3b5345e', component.options)
    }
    module.hot.accept("./seasonprices.vue?vue&type=template&id=a3b5345e&", function () {
      api.rerender('a3b5345e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HMDXg16ISGUz/JS/comp/seasonprices.vue"
export default component.exports